<div style="position: relative" class="u-shadow-mini {{ sectionclass }}">
	<div class="quick-stats">
		<div *ngIf="!isR11 && !isR9">
			<h2 class="title primary-color">{{ sectiontitle }}</h2>
		</div>
		<app-loader [showLoader]="showLoad"></app-loader>
		<div class="horizontal-quick-stats">
			<div class="quick-stats-wrapper" *ngFor="let stat of quickStatsData; let i = index">
				<div
					class="stat-div"
					[ngClass]="{ 'stat-div-last': i === quickStatsData.length - 1 }"
					appTooltip
					[attr.title]="stat?.title"
					data-size="small"
					[options]="tooltipOptions"
				>
					<div class="stats-title">{{ stat?.name }}</div>
					<div class="stat-value" *ngIf="stat.value != ''; else elseBlock">
						<span class="percentage">
							<span *ngIf="stat.hasPercent">
								<span *ngIf="!(isR702 && isEmail) && stat?.value && !showRate">
									{{ stat?.value | formatNumber }} <span class="pipe">&nbsp;|&nbsp;</span>
									<span class="quickstat-percent-value">{{ stat.percent_value }}</span>
								</span>
								<span *ngIf="isR702 && isEmail && stat?.value && !showRate">
									{{ stat.percent_value }} <span class="pipe">&nbsp;|&nbsp;</span>
									<span class="quickstat-percent-value">{{ stat?.value | formatNumber }}</span>
								</span>
								<span *ngIf="stat?.value && showRate">
									{{ stat?.value | formatNumber }}
								</span>
								<span *ngIf="!stat?.value">
									{{ stat?.value | formatNumber }}
								</span>
							</span>
							<span *ngIf="!stat.hasPercent">{{ stat?.value | formatNumber }}</span>
						</span>
					</div>
					<ng-template #elseBlock>
						<span *ngIf="stat?.name" class="u-font-small u-lh-normal u-opacity-80p" style="margin-left: 10px">
							--
						</span>
						<span *ngIf="!stat?.name" class="u-font-small u-lh-normal u-opacity-80p no-data" style="margin-left: 10px">
						</span>
					</ng-template>
					<div class="quick-stats-tooltip" *ngIf="stat.title">{{ stat.title }}</div>
				</div>
			</div>
		</div>
	</div>
</div>
